module.exports = __webpack_public_path__ + "img/still (18).90316efb.jpg";